import httpClient from '../httpClient';

const filter = async (query) => {
  return await httpClient.get(`/template_term/?${query}`);
};

export { filter };
